<template>
  <div class="package">
    <div class="header">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="组方标识">
          <el-select v-model="value1" placeholder="请选择" filterable @change="onSubmit">
            <el-option v-for="(item,index) in zufangLogo" :key="index" :value="item.zufangLogo"></el-option>
          </el-select>
          <el-input type="hidden" name="组方id" v-model="zufangId"></el-input>
        </el-form-item>
        <el-button class="filter-item" @click="handleCheck" icon="edit">查看组方修改历史</el-button>
        <el-button class="filter-item" type="primary" @click="handleCreate()" icon="edit">添加新组方</el-button>

        <!--<el-button class="filter-item" type="primary" @click="handleCompare()">组方对比</el-button>-->
      </el-form>
    </div>
    <div class="content" style="padding: 0px;">
      <el-table
        :data="tableData1"
        style="width: 100%;padding-left: 0px;text-align: center"
        border
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column type="index" label="序号" width="auto"></el-table-column>
        <el-table-column prop="value" label="药品名称" width="auto"></el-table-column>

        <el-table-column prop="number" label="数量" width="auto"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>

        <el-table-column label="操作">
          <template scope="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row,tableData1)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row :class="{addbutton:active}" v-show="this.tableData1.length">添加一味药品：
        <el-autocomplete
          :class="{autocomplete:active}"
          v-model="state"
          :fetch-suggestions="querySearchAsync"
          placeholder="按药品名搜索添加"
          @select="handleSelect"
        ></el-autocomplete>

        <el-button type="primary" @click="add_Medicine">保存</el-button>
      </el-row>
    </div>

    <!-- 点击编辑出现的弹窗 -->
    <el-dialog title="修改组方信息" :visible.sync="dialogFormVisible" size="tiny">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="药品名称">
          <el-input v-model="form.value" disabled></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="form.number"></el-input>
        </el-form-item>

        <el-form-item class="center">
          <el-button type="primary" @click="handleSave" :loading="editLoading">保存</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--    //查看组方修改历史弹框-->
    <el-dialog title="组方修改信息" :visible.sync="centerDialogVisible" width="60%"  center >
      <div>
        <el-table :data="checkList" style="width: 100%;padding-left: 0px;text-align: center" border>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="operationName" label="操作人"></el-table-column>

          <el-table-column prop="operationDateTime" label="修改时间" width="auto"></el-table-column>
          <el-table-column prop="operation" label="修改类型"></el-table-column>
          <el-table-column prop="content" label="修改内容" width="auto"></el-table-column>
        </el-table>
      </div>
      <div class="block">
        <el-pagination
                small
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync=Current
                :page-size="this.Size"
                layout="total,prev, pager, next, jumper"
                :total="this.total"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
  .block {
    margin-top: 20px;
    padding-left: 33%;
  }
.header {
  padding: 25px 18px;
  height: 40px;
}
.autocomplete {
  width: 636px;
  margin-top: 40px;
}
.package {
  width: 100%;
  padding-bottom: 20px;
  background-color: white;
}
.package .content {
  width: 98%;
  margin-left: 18px;
  background: white;
  padding-bottom: 100px;
}
.package .center {
  text-align: center;
}
.addbutton {
  margin: 30px 10px;
}
</style>
<script>
export default {
  name: "package",
  data() {
    return {
      total: 0,
      Current: 1,
      Size: 15,
      currentPage: 1,
      centerDialogVisible: false,
      itemValue: {},
      tableData1: [],
      row: {},
      index: "",
      checkList: [],
      zufangId: "",
      value1: "",
      zufangLogo: [],
      state: "",
      restaurants: [],
      active: true,
      msg: "项目>组方",
      dialogFormVisible: false,
      dialogFormVisibleadd: false,
      editLoading: false, //是否显示修改状态
      activeIndex: "1",
      formInline: {
        user: "",
        region: "",
        state: ""
      },
      form: {
        value: "",
        number: ""
      },
      tableData: []
    };
  },
  //获取所有组方标识接口
  mounted: function() {
    this.getinfo();
    //获取所有药品的接口
    this.$axios({
      url: "/api/medicines",
      method: "GET"
    })
      .then(res => {
        this.tableData = res.data.data;
        this.restaurants = this.loadAll();
      })
      .catch(err => {
        console.log(err.data);
      });
  },
  methods: {
    handleSizeChange(val) {
      this.Size = val;
    },
    handleCurrentChange(val) {
      this.Current = val;
      this.$axios({
        url: "/api/zufangs/history/pageNumber/"+this.Current+"/size/"+this.Size+"/"+this.zufangId,
        method: "GET"
      })
        .then(res => {
          if (res.data.code == 200) {
            this.centerDialogVisible = true;
            this.checkList = res.data.data.content;
            this.total = res.data.data.totalElements;
          }
        })
    },


    handleCheck: function() {

      if (this.value1 != "") {

        this.$axios({
          url: "/api/zufangs/history/pageNumber/"+this.Current+"/size/"+this.Size+"/"+this.zufangId,
          method: "GET"
        })
          .then(res => {
            if (res.data.data.content.length == 0) {
              this.$alert("没有修改记录");
              return false;
            }
            if (res.data.code == 200) {
              this.centerDialogVisible = true;
              this.checkList = res.data.data.content;
              this.total = res.data.data.totalElements;
            }
          })
          .catch(err => {
            console.log(err.data);
          });
      } else {
        this.$alert("请选择一个组方");
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#f2f2f2;color: #a4a7af;";
      }
    },
    getinfo: function() {
      this.$axios({
        url: "/api/zufangs",
        method: "GET"
      })
        .then(res => {
          this.zufangLogo = res.data.data;
        })
        .catch(err => {
          console.log(err.data);
        });
    },
    loadAll() {
      //console.log(this.tableData1);
      return this.tableData;
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return state.value.indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      this.itemValue = item;
    },
    onSubmit() {
      for (let k = 0; k < this.zufangLogo.length; k++) {
        if (this.zufangLogo[k].zufangLogo === this.value1) {
          this.zufangId = this.zufangLogo[k].id;
        }
      }
      //let zufangLogo={zufangLogo:this.value1}
      this.$axios({
        url: "/api/zufangs/getOneZufang/" + this.zufangId,
        method: "GET"
      })
        .then(res => {
          this.tableData1 = res.data.data.zufangItems;
          this.restaurants = this.loadAll();
        })
        .catch(err => {
          console.log(err);
        });
    },
    //点击编辑
    handleEdit(index, row) {
      this.row = row;
      this.index = index;
      this.dialogFormVisible = true;
      this.form = Object.assign({}, row);
      this.table_index = index;
    },
    //弹框保存方法
    handleSave() {
      this.$confirm("确认提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "cancel"
      }).then(() => {
        this.editLoading = true; //显示正在修改，圆圈跑起来
        this.tableData1[this.table_index] = this.form;
        this.tableData1.splice(this.table_index, 1, this.form);

        let zufangItem = {
          id: this.tableData1[this.index].id,
          medicineId: this.tableData1[this.index].medicineId,
          number: this.tableData1[this.index].number,
          unit: this.tableData1[this.index].unit
        };
        this.$axios({
          url: "/api/zufangs/editone",
          method: "PUT",
          data: zufangItem
        })
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
            } else {
              this.$message({
                message: "操作失败！",
                type: "success"
              });
            }
          })
          .catch(err => {
            console.log(err.data);
          });
        this.editLoading = false;
        this.dialogFormVisible = false;
      });
    },

    //删除方法
    handleDelete(index, row, rows) {
      let id = row.id;
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        rows.splice(index, 1);
        this.$axios({
          url: "/api/zufangs/" + this.zufangId + "/item/" + id,
          method: "DELETE"
        })
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: "删除成功！",
                type: "success"
              });
            } else {
              this.$message({
                message: "删除失败！",
                type: "success"
              });
            }
          })
          .catch(err => {
            console.log(err.data);
          });
      });
    },

    handleCreate() {
      this.$router.push({ path: "./addNew" });
    },
    //在组方内添加一味药
    add_Medicine: function() {
      let mid = this.itemValue.id;
      let pass = false;
      let zufangItemRequest = {
        medicineId: mid,
        number: 0,
        unit: this.itemValue.unit
      };
      for (let i = 0; i < this.tableData1.length; i++) {
        let tabId = this.tableData1[i].medicineId;
        if (tabId == mid) {
          pass = true;
          break;
        }
      }
      if (pass) {
        this.$confirm("此药物已存在，是否依旧保存?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (this.state !== "") {
              this.$axios({
                url: "/api/zufangs/addone/" + this.zufangId,
                method: "PUT",
                data: zufangItemRequest
              })
                .then(res => {
                  if (res.data.code == 200) {
                    this.$message({
                      message: "保存成功！",
                      type: "success"
                    });
                    this.state = "";
                    this.itemValue = {};
                  } else {
                    this.$message({
                      message: "保存失败！",
                      type: "success"
                    });
                  }
                  this.onSubmit();
                })
                .catch(err => {
                  console.log(err);
                });
            } else {
              this.$alert("请选择一味药品添加");
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      } else {
        this.$axios({
          url: "/api/zufangs/addone/" + this.zufangId,
          method: "PUT",
          data: zufangItemRequest
        })
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: "保存成功！",
                type: "success"
              });
              this.state = "";
              this.itemValue = {};
            } else {
              this.$message({
                message: "保存失败！",
                type: "success"
              });
            }
            this.onSubmit();
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// package.vue?550366cd